export const timingRule = {
  id: 'timing',
  name: 'Load Timing',
  description: 'Ad should load within a reasonable timeframe',

  check(session) {
    const loadStart = session.events.find(e => e.type === 'adtagstartloading');
    const adLoaded = session.events.find(e => e.type === 'adloaded');
    const adStarted = session.events.find(e => e.type === 'adstarted');
    const errors = session.events.filter(e => e.type === 'aderror');

    if (!loadStart) {
      return { status: 'na', message: 'No load event detected' };
    }

    if (errors.length > 0 && !adLoaded) {
      const errorTime = errors[0].timestamp - loadStart.timestamp;
      return {
        status: 'pass',
        message: `Error after ${errorTime}ms (fast fail is good)`,
      };
    }

    if (!adLoaded) {
      return { status: 'fail', message: 'adloaded never fired after adtagstartloading' };
    }

    const loadTime = adLoaded.timestamp - loadStart.timestamp;
    const MAX_LOAD_TIME = 10000;

    if (loadTime > MAX_LOAD_TIME) {
      return {
        status: 'fail',
        message: `Ad took ${loadTime}ms to load (threshold: ${MAX_LOAD_TIME}ms)`,
      };
    }

    let message = `Tag loaded in ${loadTime}ms`;
    if (adStarted) {
      const startTime = adStarted.timestamp - loadStart.timestamp;
      message += `, started playing at ${startTime}ms`;
    }

    return { status: 'pass', message };
  },
};
